import {useCallback, useContext, useEffect, useRef} from 'react';

import {
    useAspectsToneDynamics,
    useReviewAnalyticsAspects,
    useReviewsCountByAspects,
} from '../../../../../../service/reivew-analysis/review-aspects/review-aspects-hook';
import {isReviewAspects2FeatureEnabled} from '../../../../../../util/feature-toggle/feature-toggle';
import {AspectsByLocationsTable} from '../../../components/aspects-by-locations-table/aspects-by-locations-table';
import {KeywordsAndTopicsPageContext} from '../keywords-and-topics-page-context';

import {AspectsTable} from './aspects-table/aspects-table';
import {AspectsToneDynamicsCharts} from './aspects-tone-dynamics/aspects-tone-dynamics-charts';
import {AspectsReviewsDistributionChart} from './reviews-count-by-aspects/aspects-reviews-distribution-chart';
import {AspectsToneRadar} from './reviews-count-by-aspects/aspects-tone-radar';

export function AspectsTab(): JSX.Element {
    const {onIsFormInProgressChange} = useContext(KeywordsAndTopicsPageContext);

    const scrollRef = useRef<HTMLDivElement>(null);

    const scrollToTable = useCallback(() => {
        if (scrollRef.current) {
            scrollRef.current.scrollIntoView({behavior: 'smooth', block: 'start'});
        }
    }, []);

    const reviewAnalyticsAspects = useReviewAnalyticsAspects({
        onPageChange: scrollToTable,
    });

    const aspectsToneDynamics = useAspectsToneDynamics();

    const reviewsCountByAspects = useReviewsCountByAspects();

    useEffect(() => {
        const isLoading =
            reviewAnalyticsAspects.isLoading || aspectsToneDynamics.isLoading || reviewsCountByAspects.isLoading;

        onIsFormInProgressChange(isLoading);
    }, [
        aspectsToneDynamics.isLoading,
        onIsFormInProgressChange,
        reviewAnalyticsAspects.isLoading,
        reviewsCountByAspects.isLoading,
    ]);

    return (
        <>
            <AspectsToneDynamicsCharts aspectsToneDynamics={aspectsToneDynamics} />

            <div ref={scrollRef}>
                <AspectsTable reviewAnalyticsAspects={reviewAnalyticsAspects} />
            </div>

            {isReviewAspects2FeatureEnabled() && <AspectsByLocationsTable />}

            {isReviewAspects2FeatureEnabled() ? (
                <AspectsReviewsDistributionChart />
            ) : (
                <AspectsToneRadar reviewsCountByAspects={reviewsCountByAspects} />
            )}
        </>
    );
}
